import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
const MINUTES = [2, 3, 5, 6, 8, 11, 14];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const cycle = (showing: boolean) => {
      timeout = window.setTimeout(() => {
        if (showing) {
          setVisible(false);
          cycle(false);
        } else {
          setIndex(prev => (prev + 1) % recentPurchases.length);
          setVisible(true);
          cycle(true);
        }
      }, showing ? 5200 : 7000);
    };
    cycle(false);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const purchase = recentPurchases[index];
  const minutesAgo = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-40" data-mp="163mo17mfhyy7">
      {visible && !dismissed && <motion.div initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-30 sm:right-auto sm:max-w-[330px]" role="status" aria-live="polite" data-id="element-41" data-mp="1164o26qe2u2c">
          <div className="flex items-start gap-3 rounded-xl border border-navy-900/10 bg-white p-3 shadow-[0_18px_40px_-16px_rgba(5,15,31,0.45)]" data-id="element-42" data-mp="i8jx8u42dlf3">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50" data-id="element-43" data-mp="x6m2d8qqueyg">
              <CheckCircle2Icon aria-hidden="true" className="h-5 w-5 text-emerald-600" data-id="element-44" data-mp="s8aqksgw1udl" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-45" data-mp="28mandukft3wm">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-46" data-mp="23kbniunwop4f">
                {purchase.name}{' '}
                <span className="font-medium text-ink-700" data-id="element-47" data-mp="2ao1n2xww5ppr">
                  just purchased the digital library
                </span>
              </p>
              <p className="mt-0.5 text-[11.5px] font-medium text-ink-500" data-id="element-48" data-mp="2kn0obvfbuj2q">
                {purchase.country} · {minutesAgo} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 shrink-0 rounded-md p-1 text-ink-500 transition-colors duration-150 ease-out hover:bg-brand-50 hover:text-navy-900" data-id="element-49" data-mp="2pjhmlig8qdtj">
              <XIcon aria-hidden="true" className="h-4 w-4" data-id="element-50" data-mp="26mzn2ev5h9mq" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}